class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      if(document.getElementById("CartDrawer-Checkout")){document.getElementById("CartDrawer-Checkout").disabled = true}
      if(document.getElementById("checkout")){document.getElementById("checkout").disabled = true}
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
var get_item_url = event.target.closest('cart-remove-button').getAttribute('data-url');
var data_variant_title = event.target.closest('cart-remove-button').getAttribute('data-variant-title');
var  data_item_title = event.target.closest('cart-remove-button').getAttribute('data-item-title');
  var  data_removed_quantity = event.target.closest('.custom_cart_inner').querySelector('.quantity__input').getAttribute('value');
    var get_item_category = event.target.closest('cart-remove-button').getAttribute('data-category');
    jQuery.ajax({
          type: 'GET',
          url: get_item_url,
          dataType: 'json',
          success: function(productdata) {
             let variant_name = '';
            for (let i = 0; i < productdata.product.variants.length; i++) {
              variant_name += productdata.product.variants[i].title + ',';
            }
            const new_var_name = variant_name.slice(0, -1).trim();
                        for (let i = 0; i < productdata.product.variants.length; i++) {
              if(data_variant_title == productdata.product.variants[i].title){
 const main_price = parseInt(productdata.product.variants[i].price);
            const compare_main_price = parseInt(productdata.product.variants[i].compare_at_price);
             let discount_exist = 'NA';
            if (compare_main_price > main_price) {
               discount_exist = compare_main_price - main_price;
            }
                   var variant_string_id = productdata.product.variants[i].id.toString();
              const itemData = {
              item_id: productdata.product.variants[i].sku,
              item_name: data_item_title,
              coupon: "NA",
              discount: discount_exist,
              item_brand: "Re'equil",
              
              item_category: productdata.product.product_type,
                item_category2: get_item_category,
              item_list_id: variant_string_id,
              item_list_name: productdata.product.title,
              item_variant: new_var_name=="Default Title"? "NA" : new_var_name,
              price: main_price,
              quantity:  parseInt(data_removed_quantity)
            };
 window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            window.dataLayer.push({
              event: "remove_from_cart ",
              ecommerce: {
                currency: "INR",
                value: parseInt(productdata.product.variants[i].price),
                items: [itemData],
              },
            });
              }
            }
          },
      });

      
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
      
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if(document.getElementById("CartDrawer-Checkout")){document.getElementById("CartDrawer-Checkout").disabled = true}
    if(document.getElementById("checkout")){document.getElementById("checkout").disabled = true}
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event);
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents-wrap',
      }    
    ];
  }

  updateQuantity(line, quantity, name, event) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        jQuery.ajax({
        type: 'GET',
        url: '/cart',
        dataType: 'html',
        success: function(response){
      $(".final-flat_value_data").html($(response).find(".final-flat_value_data").html());  
        $(".RQCombineCartPageLayoutWp").html($(response).find(".RQCombineCartPageLayoutWp").html());  
          
      if( $('.RqupsellItemslideshow').length > 0 ){
      var swiper = new Swiper(".RqupsellItemslideshow", {slidesPerView: 3.4,spaceBetween: 7,navigation: {nextEl: ".NextButtonSlideshowLine",prevEl: ".PrevButtonSlideShowLine"},pagination:{el: ".swiper-pagination",type: "fraction"}})
    }
            
        }
      });

          jQuery.getJSON('/cart.js', function(cart) {
var gift_id = $(".custom_giftbox-outer").attr("gift_id");
             var new_gift_card_exist = false;
    for (var i = 0; i < cart.items.length; i++) {
      if(cart.items[i].id == gift_id){
           var new_gift_card_exist = true;
      }
          }
           if(new_gift_card_exist == true){
          if(cart.item_count == 1){

              let updates = {
   [gift_id]: 0
  };
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
  .then(response => {
    return response.json();
  }).then( results => {
              $.ajax({
           type: 'GET',
           url: '/',
           dataType: 'html',
           success: function(html_get) {
                                        if ($(".UpsellWrapperCard").hasClass("active")) {
}else{
          setTimeout(function() {
             $(".UpsellWrapperCard").removeClass("active");
          },800);
     
}
                        fetch(window.Shopify.routes.root + "?section_id=cart-icon-bubble").then(request => request.text()).then(response => {
                            const bubbleHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
                            const bubble = document.querySelector('#cart-icon-bubble');
                            bubble.innerHTML = bubbleHTML;
                        })
                        fetch(window.Shopify.routes.root + "?section_id=cart-drawer").then(res => res.text()).then(data => {
                            const newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-drawer').innerHTML;
                            const drawer = document.querySelector('cart-drawer');
                            drawer.innerHTML = newHTML;
  }); 
                          fetch(window.Shopify.routes.root + "?section_id=main-cart-items").then(res => res.text()).then(data => {
                              const cart_page_newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-items').innerHTML;
                              const cart_page = document.querySelector('cart-items');
                              cart_page.innerHTML = cart_page_newHTML;
                          });  
              $(".RQCombineCartPageLayoutWp").html($(html_get).find(".RQCombineCartPageLayoutWp").html());  
          $(".RQCartDRawerExecutionmWp ").addClass("is-empty");
           },
           });
  })
  .catch((error) => {
    console.error('Error:', error);
  });
          }
           }
  }); 
        
        if ($(".UpsellWrapperCard").hasClass("active")) {
}else{
          setTimeout(function() {
             $(".UpsellWrapperCard").removeClass("active");
          },10);
     
}
        const parsedState = JSON.parse(state);
        if(name == 'plus'){
           var get_item_category = event.target.getAttribute('data-category');
          for (let i = 0; i < parsedState.items_added.length; i++) {
                 for (let k = 0; k < parsedState.items.length; k++) {
           if(parsedState.items[k].variant_id == parsedState.items_added[i].variant_id){
      jQuery.ajax({
          type: 'GET',
          url: parsedState.items[k].url,
          dataType: 'json',
          success: function(productdata) {
             let variant_name = '';
            for (let i = 0; i < productdata.product.variants.length; i++) {
              variant_name += productdata.product.variants[i].title + ',';
            }
            const new_var_name = variant_name.slice(0, -1).trim();
                        for (let i = 0; i < productdata.product.variants.length; i++) {
              if(parsedState.items[k].variant_id == productdata.product.variants[i].id){
 const main_price = parseInt(productdata.product.variants[i].price);
            const compare_main_price = parseInt(productdata.product.variants[i].compare_at_price);
             let discount_exist = 'NA';
            if (compare_main_price > main_price) {
               discount_exist = compare_main_price - main_price;
            }
                   var variant_string_id = productdata.product.id.toString();
              const itemData = {
              item_id: productdata.product.variants[i].sku,
              item_name: parsedState.items[k].title,
              coupon: "NA",
              discount: discount_exist,
              item_brand: "Re'equil",
              
              item_category: productdata.product.product_type,
                item_category2: get_item_category,
              item_list_id: "N/A",
              item_list_name: "N/A",
              item_variant: new_var_name=="Default Title"? "NA" : new_var_name,
              price: main_price,
              quantity: 1
            };
 window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            window.dataLayer.push({
              event: "add_to_cart",
              ecommerce: {
                currency: "INR",
                value: parseInt(productdata.product.variants[i].price),
                items: [itemData],
              },
            });
              }
            }
          },
      });
           }
          }
          }
        }else if(name == 'minus'){
          var get_item_url = event.target.getAttribute('data-url');
var data_variant_title = event.target.getAttribute('data-variant-title');
var  data_item_title = event.target.getAttribute('data-item-title');
        var get_item_category = event.target.getAttribute('data-category');
    jQuery.ajax({
          type: 'GET',
          url: get_item_url,
          dataType: 'json',
          success: function(productdata) {
             let variant_name = '';
            for (let i = 0; i < productdata.product.variants.length; i++) {
              variant_name += productdata.product.variants[i].title + ',';
            }
            const new_var_name = variant_name.slice(0, -1).trim();
                        for (let i = 0; i < productdata.product.variants.length; i++) {
              if(data_variant_title == productdata.product.variants[i].title){
 const main_price = parseInt(productdata.product.variants[i].price);
            const compare_main_price = parseInt(productdata.product.variants[i].compare_at_price);
             let discount_exist = 'NA';
            if (compare_main_price > main_price) {
               discount_exist = compare_main_price - main_price;
            }
                   var variant_string_id = productdata.product.variants[i].id.toString();
              const itemData = {
              item_id: productdata.product.variants[i].sku,
              item_name: data_item_title,
              coupon: "NA",
              discount: discount_exist,
              item_brand: "Re'equil",
              
              item_category: productdata.product.product_type,
                 item_category2: get_item_category,
             item_list_id:  "N/A", //variant_string_id,
              item_list_name: "N/A", //productdata.product.title,
              item_variant: new_var_name=="Default Title"? "NA" : new_var_name,
              price: main_price,
              quantity: 1
            };
 window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            window.dataLayer.push({
              event: "remove_from_cart ",
              ecommerce: {
                currency: "INR",
                value: parseInt(productdata.product.variants[i].price),
                items: [itemData],
              },
            });
              }
            }
          },
      });
        }
         
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer'); 
        const cartOffer = document.getElementById('RQ-cart-page-offer-collection');
        const cartRecommendation = document.getElementById('RQ-cart-recommendation');
        let  NotSampleFind = 0;let OfferProduct = 0;

        if( $('[name="Eligible_products"]').length > 0){  
          var REQUIREMENT_MEETS = $('[name="Eligible_products"]').attr('minimum');
          var HAVE_MEETS = parsedState.total_price;
          var FREE_PRODUCT_IDS = $('[name="Free_products"]').val().split(",");
          var FREE_PRODUCT_IDS_LENGTH = FREE_PRODUCT_IDS.map(Number).length; 
        }



        $(parsedState.items).each(function (index, item) {
            if(item.properties){ if(item.properties['__samplePro'] == 'true' || item.properties['__samplePro']  || item.properties['__freegift'] == 'true') {}else{NotSampleFind++;} }
        }) 

        
        if( NotSampleFind != 0){

          if( $('[name="Eligible_products"]').length > 0){  
  
          var ELIGIBLE_PRODUCT_IDS = $('[name="Eligible_products"]').val().split(",");
              ELIGIBLE_PRODUCT_IDS = ELIGIBLE_PRODUCT_IDS.map(Number);
              console.log(ELIGIBLE_PRODUCT_IDS); 
          var EligibleProductAdd = false  

            $(parsedState.items).each(function (index, item) {
                $.each(ELIGIBLE_PRODUCT_IDS, function (index, id) {
                    if (id == item.product_id) {
                      EligibleProductAdd = true;
                    }
                });
            });

          if( EligibleProductAdd == true){
            
              $(parsedState.items).each(function (index, item) {
                  if(item.properties){
                    if(item.properties['__freegift'] == 'true') {
                     OfferProduct++;
                    }else{}
                  }
              }); 

            if( (OfferProduct == 0) && (parseInt(HAVE_MEETS) >= parseInt(REQUIREMENT_MEETS)) ){
              
            var EligiblePd = [];
            var FREE_PRODUCT_IDS = $('[name="Free_products"]').val().split(",");
                FREE_PRODUCT_IDS = FREE_PRODUCT_IDS.map(Number); 

                $.each(FREE_PRODUCT_IDS, function (index, vd) {
                  var l = '{"id":' + vd + ', "quantity" : ' + 1 + ',"properties": {"__freegift": true}'+ "}";
                  EligiblePd.push(JSON.parse(l));
                })

                $.post("/cart/add.js", {
                    items: EligiblePd
                }).done(function(response) {
                    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
                    if (cartOffer) cartOffer.classList.toggle('hidden', parsedState.item_count === 0);
                    if (cartRecommendation) cartRecommendation.classList.toggle('hidden', parsedState.item_count === 0);
                    fetch(window.Shopify.routes.root + "?section_id=cart-icon-bubble").then(request => request.text()).then(response => {
                        const bubbleHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
                        const bubble = document.querySelector('#cart-icon-bubble');
                        bubble.innerHTML = bubbleHTML;
                    })
                    fetch(window.Shopify.routes.root + "?section_id=cart-drawer").then(res => res.text()).then(data => {
                        const newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-drawer').innerHTML;
                        const drawer = document.querySelector('cart-drawer');
                        drawer.innerHTML = newHTML;
                    });
                  if (cartFooter){
                    fetch(window.Shopify.routes.root + "?section_id=main-cart-items").then(res => res.text()).then(data => {
                        const cart_page_newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-items').innerHTML;
                        const cart_page = document.querySelector('cart-items');
                        cart_page.innerHTML = cart_page_newHTML;
                    });   
                  }
                })
              
            }else{

              if( (OfferProduct > 0) && (parseInt(HAVE_MEETS) >= parseInt(REQUIREMENT_MEETS)) ){

                if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
                if (cartOffer) cartOffer.classList.toggle('hidden', parsedState.item_count === 0);
                if (cartRecommendation) cartRecommendation.classList.toggle('hidden', parsedState.item_count === 0);
                this.getSectionsToRender().forEach((section => {
                  const elementToReplace =
                    document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                  elementToReplace.innerHTML =
                    this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }));
                this.updateLiveRegions(line, parsedState.item_count);
                const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                  cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
                } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                  trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
                } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
                  trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
                }
                this.disableLoading();
                
              }else if( (OfferProduct == 0) && (parseInt(HAVE_MEETS) < parseInt(REQUIREMENT_MEETS)) ){

                if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
                if (cartOffer) cartOffer.classList.toggle('hidden', parsedState.item_count === 0);
                if (cartRecommendation) cartRecommendation.classList.toggle('hidden', parsedState.item_count === 0);
        
                this.getSectionsToRender().forEach((section => {
                  const elementToReplace =
                    document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                  elementToReplace.innerHTML =
                    this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }));
        
                this.updateLiveRegions(line, parsedState.item_count);
                const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                  cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
                } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                  trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
                } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
                  trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
                }
                this.disableLoading();
                
              }else if( (OfferProduct > 0) && (parseInt(HAVE_MEETS) < parseInt(REQUIREMENT_MEETS)) ){
                var REMOVE_FREE_PRODUCTS = '';
                $.when(jQuery.getJSON('/cart.js', function (cart) {
                  $(cart.items).each(function (index, item) {
                    if(item.properties){
                        if(item.properties["__freegift"] === "true"){
                          REMOVE_FREE_PRODUCTS += `&updates[${item.key}]=0`;
                        }
                     }
                  });
                })
                ).then(function () {
                  $.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    data: REMOVE_FREE_PRODUCTS,
                    dataType: 'json',
                    success: function (response) {
                        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
                        if (cartOffer) cartOffer.classList.toggle('hidden', parsedState.item_count === 0);
                        if (cartRecommendation) cartRecommendation.classList.toggle('hidden', parsedState.item_count === 0);
                        fetch(window.Shopify.routes.root + "?section_id=cart-icon-bubble").then(request => request.text()).then(response => {
                            const bubbleHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
                            const bubble = document.querySelector('#cart-icon-bubble');
                            bubble.innerHTML = bubbleHTML;
                        })
                        fetch(window.Shopify.routes.root + "?section_id=cart-drawer").then(res => res.text()).then(data => {
                            const newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-drawer').innerHTML;
                            const drawer = document.querySelector('cart-drawer');
                            drawer.innerHTML = newHTML;
                        });
                        if (cartFooter){
                          fetch(window.Shopify.routes.root + "?section_id=main-cart-items").then(res => res.text()).then(data => {
                              const cart_page_newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-items').innerHTML;
                              const cart_page = document.querySelector('cart-items');
                              cart_page.innerHTML = cart_page_newHTML;
                          });   
                        }    
                    }
                  });
                });
                
              }
              
            }
            
          }else{

              $(parsedState.items).each(function (index, item) {
                  if(item.properties){
                    if(item.properties['__freegift'] == 'true') {
                     OfferProduct++;
                    }else{}
                  }
              });   
              if( (OfferProduct > 0) && (parseInt(HAVE_MEETS) < parseInt(REQUIREMENT_MEETS)) ){
  
                  var REMOVE_FREE_PRODUCTS = '';
                  $.when(jQuery.getJSON('/cart.js', function (cart) {
                    $(cart.items).each(function (index, item) {
                      if(item.properties){
                          if(item.properties["__freegift"] === "true"){
                            REMOVE_FREE_PRODUCTS += `&updates[${item.key}]=0`;
                          }
                       }
                    });
                  })
                  ).then(function () {
                    $.ajax({
                      type: 'POST',
                      url: '/cart/update.js',
                      data: REMOVE_FREE_PRODUCTS,
                      dataType: 'json',
                      success: function (response) {
                          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
                          if (cartOffer) cartOffer.classList.toggle('hidden', parsedState.item_count === 0);
                          if (cartRecommendation) cartRecommendation.classList.toggle('hidden', parsedState.item_count === 0);
                          fetch(window.Shopify.routes.root + "?section_id=cart-icon-bubble").then(request => request.text()).then(response => {
                              const bubbleHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
                              const bubble = document.querySelector('#cart-icon-bubble');
                              bubble.innerHTML = bubbleHTML;
                          })
                          fetch(window.Shopify.routes.root + "?section_id=cart-drawer").then(res => res.text()).then(data => {
                              const newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-drawer').innerHTML;
                              const drawer = document.querySelector('cart-drawer');
                              drawer.innerHTML = newHTML;
                          });
                          if (cartFooter){
                            fetch(window.Shopify.routes.root + "?section_id=main-cart-items").then(res => res.text()).then(data => {
                                const cart_page_newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-items').innerHTML;
                                const cart_page = document.querySelector('cart-items');
                                cart_page.innerHTML = cart_page_newHTML;
                            });   
                          }    
                      }
                    });
                  });
                
            }else if( (OfferProduct > 0) && (EligibleProductAdd == false) ){

                var REMOVE_FREE_PRODUCTS = '';
                $.when(jQuery.getJSON('/cart.js', function (cart) {
                  $(cart.items).each(function (index, item) {
                    if(item.properties){
                        if(item.properties["__freegift"] === "true"){
                          REMOVE_FREE_PRODUCTS += `&updates[${item.key}]=0`;
                        }
                     }
                  });
                })
                ).then(function () {
                  $.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    data: REMOVE_FREE_PRODUCTS,
                    dataType: 'json',
                    success: function (response) {
                        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
                        if (cartOffer) cartOffer.classList.toggle('hidden', parsedState.item_count === 0);
                        if (cartRecommendation) cartRecommendation.classList.toggle('hidden', parsedState.item_count === 0);
                        fetch(window.Shopify.routes.root + "?section_id=cart-icon-bubble").then(request => request.text()).then(response => {
                            const bubbleHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
                            const bubble = document.querySelector('#cart-icon-bubble');
                            bubble.innerHTML = bubbleHTML;
                        })
                        fetch(window.Shopify.routes.root + "?section_id=cart-drawer").then(res => res.text()).then(data => {
                            const newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-drawer').innerHTML;
                            const drawer = document.querySelector('cart-drawer');
                            drawer.innerHTML = newHTML;
                        });
                        if (cartFooter){
                          fetch(window.Shopify.routes.root + "?section_id=main-cart-items").then(res => res.text()).then(data => {
                              const cart_page_newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-items').innerHTML;
                              const cart_page = document.querySelector('cart-items');
                              cart_page.innerHTML = cart_page_newHTML;
                          });   
                        }    
                    }
                  });
                });
              
            }else{
          
                if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
                if (cartOffer) cartOffer.classList.toggle('hidden', parsedState.item_count === 0);
                if (cartRecommendation) cartRecommendation.classList.toggle('hidden', parsedState.item_count === 0);
                this.getSectionsToRender().forEach((section => {
                  const elementToReplace =
                    document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                  elementToReplace.innerHTML =
                    this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }));
                this.updateLiveRegions(line, parsedState.item_count);
                const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                  cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
                } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                  trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
                } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
                  trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
                }
                this.disableLoading();
  
            }            

            
          }

        }
          else{

            if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
            if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
            if (cartOffer) cartOffer.classList.toggle('hidden', parsedState.item_count === 0);
            if (cartRecommendation) cartRecommendation.classList.toggle('hidden', parsedState.item_count === 0);
    
            this.getSectionsToRender().forEach((section => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }));
    
            this.updateLiveRegions(line, parsedState.item_count);
            const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
              cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
            } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
            } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
            }
            this.disableLoading();
            
          }
            
        }else{

            fetch('/cart/clear', { ...fetchConfig(), ...{ body } })
              .then((response) => {
                return response.text();
              })
              .then((state) => {
              const parsedState = JSON.parse(state);
              this.classList.toggle('is-empty', parsedState.item_count === 0);
              const cartDrawerWrapper = document.querySelector('cart-drawer');
              const cartFooter = document.getElementById('main-cart-footer'); 
              const cartOffer = document.getElementById('RQ-cart-page-offer-collection');
              const cartRecommendation = document.getElementById('RQ-cart-recommendation');

              if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);  
              if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
              if (cartOffer) cartOffer.classList.toggle('hidden', parsedState.item_count === 0);  
              if (cartRecommendation) cartRecommendation.classList.toggle('hidden', parsedState.item_count === 0);
      
              this.getSectionsToRender().forEach((section => {
                const elementToReplace =
                  document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                elementToReplace.innerHTML =
                  this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              }));
      
              this.updateLiveRegions(line, parsedState.item_count);
              const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
              if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
              } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
              } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
                trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
              }
              this.disableLoading();
                
             }).catch(() => {
              this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
              const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
              errors.textContent = window.cartStrings.error;
              this.disableLoading();
            });
                  
        }

        if( $('#RQ-cart-page-offer-collection').length > 0 ){
          if( HAVE_MEETS >= 100000){$('#RQ-cart-page-offer-collection').removeClass('hidden'); }else{$('#RQ-cart-page-offer-collection').addClass('hidden');}        
        }

        if(document.querySelectorAll('.new_custom_drawer_products').length > 0){
      function FounderCookie(cookieName) {
          const cookies = document.cookie.split(';');
          for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.startsWith(cookieName + '=')) {
              return true;
            }
          }
          return false;
        }
    
        function startTimer(duration, display) {
          var timer = duration, minutes, seconds;
          setInterval(function () {
              minutes = parseInt(timer / 60, 10)
              seconds = parseInt(timer % 60, 10);
              // minutes = minutes < 10 ? "0" + minutes : minutes;
              // seconds = seconds < 10 ? "0" + seconds : seconds;
    
              var minutes_fst = minutes.toString().split("").map(Number)[0];
              var minutes_scd = minutes.toString().split("").map(Number)[1]; 
    
              var seconds_fst = seconds.toString().split("").map(Number)[0];
              var seconds_scd = seconds.toString().split("").map(Number)[1];        
    
              if(typeof minutes_scd !== 'undefined'){
                display.querySelector('#timer-hours').innerHTML = `<span>${minutes_fst}</span><span>${minutes_scd}</span>`;
              }else{
                display.querySelector('#timer-hours').innerHTML =  `<span>0</span><span>${minutes_fst}</span>`;
              }  
    
              if(typeof seconds_scd !== 'undefined'){
                display.querySelector('#timer-minutes').innerHTML = `<span>${seconds_fst}</span><span>${seconds_scd}</span>`;
              }else{
                display.querySelector('#timer-minutes').innerHTML =  `<span>0</span><span>${seconds_fst}</span>`;
              }         
    
                
             if (FounderCookie('offerInvalid')) { }else{
              if (--timer < 0) {
                const expirationDate = new Date();
                expirationDate.setDate(expirationDate.getDate() + 7);
                document.cookie = `offerInvalid=true; expires=${expirationDate.toUTCString()}; path=/`;
              }
             }
    
              if (FounderCookie('offerInvalid')) {
                  if(document.querySelector('.drawer_timer_outer-wrapp')){
                    document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
                  }
                  if(document.querySelector('.new_custom_drawer_products')){
                    document.querySelector('.new_custom_drawer_products').style.display = 'none';
                  }
                  window.localStorage.removeItem("seconds")
                  window.localStorage.removeItem("minutes")
              }else{
                if(document.querySelector('.drawer_timer_outer-wrapp')){
                  document.querySelector('.drawer_timer_outer-wrapp').style.display = 'block';
                }
               if(document.querySelector('.new_custom_drawer_products')){
                document.querySelector('.new_custom_drawer_products').style.display = 'block';
               }
                  window.localStorage.setItem("seconds",seconds)
                  window.localStorage.setItem("minutes",minutes)            
              }
    
      
            
    
          }, 1000);
        }


        var sec  = parseInt(window.localStorage.getItem("seconds"));
        var min = parseInt(window.localStorage.getItem("minutes")); 
      
      if (FounderCookie('offerInvalid')) {
          if(document.querySelector('.drawer_timer_outer-wrapp')){
            document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
          }
          if(document.querySelector('.new_custom_drawer_products')){
            document.querySelector('.new_custom_drawer_products').style.display = 'none';
          }
          window.localStorage.removeItem("seconds")
          window.localStorage.removeItem("minutes")
      }else{
            if(document.querySelector('.drawer_timer_outer-wrapp')){
              document.querySelector('.drawer_timer_outer-wrapp').style.display = 'block';
            }
           if(document.querySelector('.new_custom_drawer_products')){
            document.querySelector('.new_custom_drawer_products').style.display = 'block';
           }        
      }

        if(parseInt(min*sec)){
          var fiveMinutes = (parseInt(min*60)+sec);
        }else{
          var fiveMinutes = 60 * 30;
        }      
      
      var display = document.querySelector('#timer-box');
      if(parseInt(min) == 0){
          if(document.querySelector('.drawer_timer_outer-wrapp')){
            document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
          }
          if(document.querySelector('.new_custom_drawer_products')){
            document.querySelector('.new_custom_drawer_products').style.display = 'none';
          }
          window.localStorage.removeItem("seconds")
          window.localStorage.removeItem("minutes")
          const expirationDate = new Date();
          expirationDate.setDate(expirationDate.getDate() + 7);
          document.cookie = `offerInvalid=true; expires=${expirationDate.toUTCString()}; path=/`;        
      }else{
        startTimer(fiveMinutes, display);
      }
        }else{
          document.querySelector('.drawer_timer_outer-wrapp').classList.add('hidden');
        }
          Smile.ready().then(smileInstance => {
  $(".int_discount_text span.sweettooth-points-balance").html(smileInstance.customer.points_balance);
}).catch(err => {
  // An error has occurred will initializing smile.
});
        
      }).catch(() => {
        
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
    if(document.getElementById("CartDrawer-Checkout")){document.getElementById("CartDrawer-Checkout").disabled = false}
    if(document.getElementById("checkout")){document.getElementById("checkout").disabled = false}    
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};
